<form
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  *ngIf="form"
  class="investment-form"
  [class.investment-form--locked]="shouldUseLockedFieldStyle"
  autocomplete="off"
>
  <nb-card
    [ngClass]="customNbCardClass"
    [ngStyle]="inWizard ? { width: '100%' } : {}"
  >
    <nb-card-header>
      @if (isProposedLockedByWorkflow || isLocked) {
        @if (readOnly) {
          <a
            nbButton
            ghost
            status="primary"
            class="lock-button"
            nbTooltipPlacement="bottom"
          >
            <i class="fa-kit fa-light-lock-circle-question fa-xl"></i>
          </a>
        } @else {
          <a
            nbButton
            ghost
            status="primary"
            class="lock-button"
            [nbTooltip]="'Given the investment status some fields are not editable' | translate"
            nbTooltipPlacement="bottom"
          >
            <i class="fa-kit fa-light-lock-circle-question fa-xl"></i>
          </a>
        }
      }
      @if (!initiative) {
        <div class="title">
          @if (investmentSiteName) {
            <span class="title-site">{{ investmentSiteName }}</span>
            <span class="title-separator"> &gt; </span>
          }
          <span class="title-entity">{{ investment?.label }}</span>
        </div>
        <!-- Header action icons -->
        <div class="fiche-header-icons">
          <span class="fiche-header-icon" [nbPopover]="investmentDeleteMenuTpl" nbPopoverPlacement="bottom" nbPopoverClass="investment-kebab-menu"
                #investmentKebabPopover="nbPopover">
            <i class="fa-light fa-ellipsis-vertical"></i>
          </span>
          <ng-template #investmentDeleteMenuTpl>
            <div class="investment-kebab-dropdown-item" [class.disabled]="!canDeleteInvestment"
                 (click)="onDeleteMenuItemClick(investmentKebabPopover)">
              {{ 'Delete this investment' | translate }}
            </div>
          </ng-template>
          @if (showLinkedEquipement()) {
            <span class="fiche-header-icon fiche-header-icon--light" (click)="openLinkedEquipmentDialog()">
              <i class="fa-light fa-gear" style="margin-right: 0.1em"></i>
              <span>({{ (investment.asset ? 1 : 0) + (investment.next_asset && !investment.asset ? 1 : 0) }})</span>
            </span>
          }
          <span class="fiche-header-icon" (click)="openInvestmentSheet()">
            <fa-icon icon="browsers"></fa-icon>
          </span>
          <span class="fiche-header-icon close-btn" (click)="confirmClose()">
            <i class="fa-light fa-x"></i>
          </span>
        </div>
      } @else {
        @if (!inWizard) {
          <div class="title">
          @if (investmentSiteName) {
            <span class="title-site">{{ investmentSiteName }}</span>
            <span class="title-separator"> &gt; </span>
          }
          <span class="title-entity">{{ investment?.label }}</span>
        </div>
          <div style="position: absolute; right: 20px; top: 12px; display: flex; align-items: center; gap: 16px;">
            <span class="close-btn" (click)="confirmClose()" style="font-size:16px; cursor:pointer; display: flex; align-items: center;">
              <i class="fa-light fa-x"></i>
            </span>
          </div>
        }
      }
    </nb-card-header>

    <!-- TABS -->
    <!-- FORM -->
    <nb-card-body>
      <!-- TABS -->
      @if(!initiative) {
        <div class="form-tabs-bar">
          <div class="form-tab" [class.active]="activeFormTab === 'description'" (click)="activeFormTab = 'description'">
            {{ "Description" | translate }}
          </div>
          <div class="form-tab" [class.active]="activeFormTab === 'documents'" (click)="activeFormTab = 'documents'">
            {{ "Documents" | translate }}
            @if (docCount > 0) {
              <span class="form-tab-count">({{ docCount }})</span>
            }
          </div>
        </div>
      }
      <div class="form-group" [style.display]="activeFormTab === 'description' ? '' : 'none'">
        @if (!initiative) {
          <!-- Investment Form -->

          <!-- LABEL -->
          <div class="form-field" [class.disabled]="shouldUseLockedFieldStyle">
            <label for="label">{{ "Investment label" | translate }}</label>
            <input nbInput id="label" type="text" formControlName="label" (blur)="autoSave('label')" fullWidth />
          </div>

          <!-- PERIMETER -->
          <div class="form-field display-with-link {{ readOnly ? 'disabled' : null }}">
            <label for="perimeter">{{ 'Perimeter' | translate }}</label>
            <div id="perimeter">
              <span>{{ getPerimeterDisplayName(selectedPerimeter) }}</span>
            </div>
          </div>

          <!-- INVESTMENT TYPE -->
          <div class="form-field" [class.disabled]="shouldUseLockedFieldStyle">
            <label for="investment_type">{{ "Investment type" | translate }}</label>
            <input nbInput id="investment_type" type="text" [value]="selectedInvestmentTypeLabel" fullWidth readonly />
          </div>

          <!-- BUDGET -->
          <div
            class="form-field display-with-link"
            [class.disabled]="shouldUseLockedFieldStyle"
            [style.cursor]="shouldUseLockedFieldStyle ? 'default' : 'pointer'"
            (click)="openDialogModify('BUDGET_ALLOCATION')"
          >
            <label for="budget">{{ "Budget" | translate }}</label>
            <div id="budget">
              <span>{{ getFormattedBudgetAmount() }} {{ getBudgetYear() }} ({{ getBudgetOrigin() }})</span>
              @if (!shouldUseLockedFieldStyle) {
                <span class="right-chevron"><i class="far fa-chevron-right fal"></i></span>
              }
            </div>
          </div>

          <!-- STATUS -->
          @if (form.get('status')?.disabled) {
            <div class="form-field disabled keep-text-color" [nbSpinner]="(statuses$ | async)?.loading" (click)="openDialogModify('BUDGET_ALLOCATION')">
              <label for="status">{{ "Status" | translate }}</label>
              <div id="status">{{ getStatusDisplay() }}</div>
            </div>
          } @else {
            <div
              class="form-field display-with-link keep-text-color"
              [nbSpinner]="(statuses$ | async)?.loading"
              style="cursor: pointer"
              (click)="openDialogModify('BUDGET_ALLOCATION')"
            >
              <label for="status">{{ "Status" | translate }}</label>
              <div id="status">
                <span>{{ getStatusDisplay() }}</span>
                <span class="right-chevron"><i class="far fa-chevron-right fal"></i></span>
              </div>
            </div>
          }

          <!-- PRIORITY -->
          <div class="form-field" [class.disabled]="form.get('priority')?.disabled" [nbSpinner]="(priorities$ | async)?.loading">
            <label for="priority">{{ "Priority" | translate }}</label>
            @if (form.get('priority')?.disabled) {
              <div id="priority">
                {{ getPriorityDisplay() }}
              </div>
            } @else {
              <nb-select
                id="priority"
                formControlName="priority"
                fullWidth
                placeholder="-"
              >
                @for (p of (priorities$ | async)?.data; track p) {
                  <nb-option [value]="p.id">
                    {{ p.name }}
                  </nb-option>
                }
              </nb-select>
            }
          </div>

          <!-- TAGS -->
          @if ((reasons$ | async)?.data?.length) {
            <div class="form-field">
              <label for="reasons">{{ "Tag" | translate }}</label>
              @if (form.get('reasons')?.disabled) {
                <div id="reasons">
                  {{ getReasonsDisplay() }}
                </div>
              } @else {
                <nb-select
                  id="reasons"
                  formControlName="reasons"
                  placeholder="-"
                  fullWidth
                >
                  @for (r of (reasons$ | async)?.data; track r) {
                    <nb-option [value]="r.id">
                      {{ r.name }}
                    </nb-option>
                  }
                </nb-select>
              }
            </div>

            <!-- Energy Action -->
              <!-- PRICE -->
              <!-- <ng-container *ngTemplateOutlet="price"></ng-container> -->

              <!-- BUDGET ORIGIN -->
              <!-- <ng-container *ngTemplateOutlet="budgetOrigin"></ng-container> -->

              <!-- YEAR -->
              <!-- <ng-container *ngTemplateOutlet="year"></ng-container> -->

              <!-- BUDGET SCOPES -->
              <!-- <ng-container *ngTemplateOutlet="budgetScopes"></ng-container> -->
          }

          <!-- INVESTMENT NOTATION -->
          @if (investment.investment_type_object?.maintenance && investment.asset) {
            <div class="form-field" [class.disabled]="form.get('investment_notation')?.disabled">
              <label for="investment_notation">{{ "Investment Notation" | translate }}</label>
              @if (form.get('investment_notation')?.disabled) {
                <div id="investment_notation_fmt">
                  {{ getFormattedInvestmentNotation() }}
                </div>
              } @else {
                <input nbInput id="investment_notation" type="text" formControlName="investment_notation" fullWidth
                       readonly (click)="openInvestmentNotation()"/>
              }
            </div>
          }

          <!-- IMPACTS -->
          @if ((impacts$ | async)?.data?.length) {
          <div class="form-field" [class.disabled]="form.get('impact_roadmap_indicators')?.disabled" [nbSpinner]="(impacts$ | async)?.loading">
            <label for="impact_roadmap_indicators">{{ "Impact" | translate }}</label>
            @if (form.get('impact_roadmap_indicators')?.disabled) {
              <div id="impact_roadmap_indicators">
                {{ getImpactDisplay() }}
              </div>
            } @else {
              <nb-select
                id="impact_roadmap_indicators"
                formControlName="impact_roadmap_indicators"
                placeholder="-"
                fullWidth
                multiple
              >
                @for (i of (impacts$ | async)?.data; track i) {
                  <nb-option [value]="i.id">
                    {{ i.name }}
                  </nb-option>
                }
              </nb-select>
            }
          </div>
          }

          <div class="form-field display-with-link {{ (readOnly || isLocked) ? 'disabled' : null }}"
               [style.cursor]="!(readOnly || isLocked) ? 'pointer' : 'default'"
               (click)="openTaxonomyDialog()">
            <label for="aligned_taxonomy">{{ "Potentially aligned with EU taxonomy" | translate }}</label>
            <div id="aligned_taxonomy">
              <span>{{ getInvestmentTaxonomy() }}</span>
              @if (!(readOnly || isLocked)) {
                <span class="right-chevron"><i class="far fa-chevron-right fal"></i></span>
              }
            </div>
          </div>

          <!-- Technical Category (Nomenclature technique) -->
          <div class="form-field display-with-link {{ (readOnly || isLocked || investment.asset) ? 'disabled' : null }}"
               [style.cursor]="!(readOnly || isLocked || investment.asset) ? 'pointer' : 'default'"
               (click)="openCategorySelector()">
            <label for="technical_category">{{ "Technical category" | translate }}</label>
            <div id="technical_category">
              <span>{{ getTechnicalCategoryDisplay() }}</span>
              @if (!(readOnly || isLocked || investment.asset)) {
                <span class="right-chevron"><i class="far fa-chevron-right fal"></i></span>
              }
            </div>
          </div>

          <!-- FURTHER INFORMATION -->
          @if ((furtherInformations$ | async)?.data?.length) {
            <div class="form-field" [class.disabled]="form.get('further_information')?.disabled" [nbSpinner]="(furtherInformations$ | async)?.loading">
              <label for="further_information">{{ "Further information" | translate }}</label>
              @if (form.get('further_information')?.disabled) {
                <div id="further_information">
                  {{ getFurtherInformationDisplay() }}
                </div>
              } @else {
                <nb-select
                  id="further_information"
                  formControlName="further_information"
                  fullWidth
                  placeholder="-"
                >
                  @for (fi of (furtherInformations$ | async)?.data; track fi) {
                    <nb-option [value]="fi.id">
                      {{ fi.name }}
                    </nb-option>
                  }
                </nb-select>
              }
            </div>
          }
          <div
            style="display: flex; justify-content: center; padding: 4px 0; background-color: #f0f0f0; color: #000; font-size: 12px ">
            {{ "Optional" | translate }}
          </div>

          <!-- 1. Gain energy / carbone -->
          @if (energyModuleEnabled) {
            <div class="form-field display-with-link"
                 [class.disabled]="shouldUseLockedFieldStyle"
                 [class.display-with-link]="!isLocked"
                 (click)="openDialogModify('GAIN_ENERGY_CARBON')"
            >
              <label for="gain">{{ "Gain energy / carbone" | translate }}</label>
              <div>
                <span id="gain">{{ getGainDisplay() }}</span>
                <span class="right-chevron" *ngIf="!isLocked"><i class="far fa-chevron-right fal"></i></span>
              </div>
            </div>
          }

          <!-- 2. Linked equipment -->
          @if (showLinkedEquipement()) {
            <div class="form-field display-with-link keep-text-color" (click)="openLinkedEquipmentDialog()" [class.disabled]="shouldUseLockedFieldStyle">
              <label>{{ "Linked equipment" | translate }}</label>
              <div>
                <span>{{ getLinkedEquipmentDisplay() }}</span>
                <span class="right-chevron" *ngIf="!isLocked"><i class="far fa-chevron-right fal"></i></span>
              </div>
            </div>
          }

          <!-- 3. Refacturation preneurs -->
          <div class="form-field" [class.disabled]="form.get('has_invoicing')?.disabled">
            <label for="refacturation_preneurs">{{ "Refacturation preneurs" | translate }}</label>
            @if (form.get('has_invoicing')?.disabled) {
              <div id="refacturation_preneurs">
                {{ getRefacturationPreneursDisplay() }}
              </div>
            } @else {
              <nb-select
                id="refacturation_preneurs"
                formControlName="has_invoicing"
                fullWidth
                placeholder="-"
                (selectedChange)="onRefacturationChange($event)">
                <nb-option [value]="true">{{ "Yes" | translate }}</nb-option>
                <nb-option [value]="false">{{ "No" | translate }}</nb-option>
                <nb-option [value]="null">{{ "To be defined" | translate }}</nb-option>
              </nb-select>
            }
          </div>

          <!-- 4. Distribution key (Clé de répartition) -->
          @if (canEditQuotePart()) {
            <div class="form-field" [class.disabled]="shouldUseLockedFieldStyle">
              <label for="distribution_key">{{ "Payer distribution key" | translate }}</label>
              <div id="distribution_key">
                <span>{{ getDistributionKeyDisplay() }}</span>
              </div>
            </div>
          }

          <!-- 5. Quote part details (Détails quotepart) -->
          @if (canEditQuotePart()) {
            <div class="form-field" [class.disabled]="shouldUseLockedFieldStyle">
              <label for="quote_part_details">{{ "Quote part details" | translate }}</label>
              <div id="quote_part_details">
                <span>{{ getQuotePartDetailsDisplay() }}</span>
              </div>
            </div>
          }

          <!-- 6. Spending category (Catégorie de dépense) -->
          <div class="form-field display-with-link" [class.disabled]="form.get('investment_category')?.disabled">
            <label for="investment_category">{{ "Spending category" | translate }}</label>
            <div id="investment_category" (click)="spendingCategoryClicked()">
              {{ getInvestmentCategoryDisplay() }}
              <span class="right-chevron" *ngIf="!isLocked"><i class="far fa-chevron-right fal"></i></span>
            </div>
          </div>

          <!-- 7. Project code (Code projet) - read-only -->
          @if ((customerConfig$ | async)?.show_investment_project_code) {
            <div class="form-field">
              <label for="project_code">{{ "Project code" | translate }}</label>
              <div id="project_code">
                {{ form.get('project_code')?.value || '-' }}
              </div>
            </div>
          }

          <!-- GTP code (kept in original position for conditional display) -->
          @if ((customerConfig$ | async)?.show_investment_gtp_code && statusValid && !shouldHideGtpCode()) {
            <div class="form-field" [class.disabled]="shouldUseLockedFieldStyle">
              <label for="gtp_code_2">{{ "GTP code" | translate }}</label>
              <div class="input-group">
                @if (investment.reference_prefix) {
                  <span class="input-group-text">{{ investment.reference_prefix }}</span>
                }
                <input nbInput id="gtp_code_2" type="text" formControlName="gtp_code" class="ms-1" placeholder="-" />
              </div>
            </div>
          }

          <!-- Customize code (kept in original position for conditional display) -->
          @if ((customerConfig$ | async)?.show_investment_custom_code) {
            <ng-container *ngTemplateOutlet="customCode; context: { optional: true }"></ng-container>
          }


          <!-- 8. Linked investment(s) -->
          <div
            class="form-field display-with-link keep-text-color"
            [class.disabled]="readOnly"
            style="cursor: pointer;"
            (click)="openLinkInvestmentsList()"
          >
            <label for="linked_investment">{{ "Linked investment(s)" | translate }}</label>
            <div id="linked_investment">
              <span>{{ getLinkedInvestmentsDisplay() }}</span>
              <span class="right-chevron"><i class="far fa-chevron-right fal"></i></span>
            </div>
          </div>

          <!-- 9. Comments (Commentaires) -->
          <div class="form-field" [class.disabled]="form.get('comments')?.disabled">
            <label for="comments">{{ "Comment" | translate }}</label>
            @if (form.get('comments')?.disabled) {
              <div id="comments" style="padding-bottom: 1rem;">
                {{ getCommentsDisplay() }}
              </div>
            } @else {
              <textarea placeholder="-" nbInput id="comments" type="text" formControlName="comments" fullWidth
                        rows="5" (blur)="autoSave('comments')"></textarea>
            }
          </div>

        } @else {
          <!-- INITIATIVE BUDGET SHEET -->
          @if (selectedTabId === 1) {

            <!-- PRICE -->
            <ng-container *ngTemplateOutlet="price;"></ng-container>

            <!-- STATUS -->
            <ng-container *ngTemplateOutlet="status"></ng-container>

            <!-- YEAR -->
            <ng-container *ngTemplateOutlet="year"></ng-container>

            <!-- BUDGET ORIGIN -->
            <ng-container *ngTemplateOutlet="budgetOriginOutlet; context: { optional: false }"></ng-container>

            <!-- BUDGET SCOPES -->
            <ng-container *ngTemplateOutlet="budgetScopesOutlet"></ng-container>

            <!-- Customize code -->
            @if ((customerConfig$ | async)?.show_investment_custom_code) {
              <ng-container *ngTemplateOutlet="customCode; context: { optional: true }"></ng-container>
            }

            <!-- ENERGY-ONLY FIELDS: saved on the linked initiative, shown only when the energy module is enabled -->
            @if (energyModuleEnabled && energyFieldsInitiativeId !== null) {
              <div class="form-field">
                <label for="cee_bonus">{{ "EC Bonus the year after the action (k{currency})" | translate:{currency:i18n.getCurrency()} }}</label>
                <input
                  nbInput
                  id="cee_bonus"
                  type="number"
                  [(ngModel)]="ceeBonus"
                  [ngModelOptions]="{standalone: true}"
                  (blur)="saveCeeBonus()"
                  fullWidth
                  placeholder="-"
                />
              </div>
              <div class="form-field">
                <label for="yearly_cost_savings">{{ "Other reccuring bonuses (k{currency} / year)" | translate:{currency:i18n.getCurrency()} }}</label>
                <input
                  nbInput
                  id="yearly_cost_savings"
                  type="number"
                  [(ngModel)]="yearlyCostSavings"
                  [ngModelOptions]="{standalone: true}"
                  (blur)="saveYearlyCostSavings()"
                  fullWidth
                  placeholder="-"
                />
              </div>
            }
          }
        }
      </div>

      <!-- DOCUMENTS TAB -->
      @if (activeFormTab === 'documents' && !initiative) {
        <app-entity-documents-tab
          [investIds]="[investment.id]"
          [assetIds]="[]"
          [actionIds]="[]"
          [perimeterIds]="investment.multi_perimeter?.id ? [investment.multi_perimeter.id] : []"
          [entityLabel]="investment.label"
          (documentsChanged)="loadDocumentCount()"
        ></app-entity-documents-tab>
      }
    </nb-card-body>

    <!-- CANCEL OR SUBMIT -->
    @if (anyFieldValueChanged() && !inWizard && !this.readOnly && activeFormTab === 'description') {
      <nb-card-footer class="{{ initiative ? 'initiative' : 'investment' }} wizard">
        <button nbButton type="submit" class="wizard-next" [disabled]="!isFormValid()">
          {{ "Save" | translate }}
        </button>
      </nb-card-footer>
    }
  </nb-card>

  <!-- Templates of the fields that are common to the investment form and the initiative form -->

  <!-- PRICE -->
  <ng-template #price>
    <div class="form-field" [class.highlighted]="!form.get('price')?.value">
      <label for="price">{{ "Amount" | translate }} (€)</label>
      <input
        nbInput
        id="price"
        type="number"
        formControlName="price"
        fullWidth
        placeholder="-"
        min="0"
        integerOnly
      />
    </div>
  </ng-template>

  <!-- Year -->
  <ng-template #year>
    <div class="form-field">
      <label for="year">{{ "Year" | translate }}</label>
      <nb-select id="year" formControlName="year" fullWidth placeholder="-">
        @for (y of years; track y) {
          <nb-option [value]="y">
            {{ y }}
          </nb-option>
        }
      </nb-select>
    </div>
  </ng-template>

  <!-- STATUS -->
  <ng-template #status let-showInvestment="showInvestment">
    <div class="form-field" [nbSpinner]="(statuses$ | async)?.loading">
      <label for="status">
        @if (!showInvestment) {
          {{ "Status" | translate }}
        } @else {
          {{ "Investment status" | translate }}
        }
      </label>
      <nb-select id="status" formControlName="status" fullWidth placeholder="-">
        @for (s of (statuses$ | async)?.data; track s) {
          <nb-option [value]="s.id">
            {{ s.name }}
          </nb-option>
        }
      </nb-select>
    </div>
  </ng-template>

  <!-- BUDGET SCOPES -->
  <ng-template #budgetScopesOutlet>
    <div class="form-field">
      <label for="budget_scopes">{{ "Budget scope" | translate }}</label>
      <nb-select id="budget_scopes" [(ngModel)]="selectedBudgetScopeId" (ngModelChange)="selectBudgetScope()"
                 fullWidth placeholder="-" [ngModelOptions]="{standalone: true}">
        @for (bs of budgetScopes; track bs) {
          <nb-option [value]="bs.id">
            {{ bs.name }}
          </nb-option>
        }
      </nb-select>
    </div>
  </ng-template>

  <!-- BUDGET ORIGIN -->
  <ng-template #budgetOriginOutlet let-optional="optional">
    <div class="form-field">
      <label for="budget_origin">
        {{ "Budget origin" | translate }}
      </label>
      <nb-select id="budget_origin" formControlName="budget_origin" fullWidth placeholder="-">
        @for (bo of budgetOrigins; track bo) {
          <nb-option [value]="bo.id">
            {{ bo.name }}
          </nb-option>
        }
      </nb-select>
    </div>
  </ng-template>

  <!-- Custom code -->
  <ng-template #customCode let-optional="optional">
    <div class="form-field">
      <label for="custom_code">{{ investmentCodeFieldName }}</label>
      <input nbInput id="custom_code" type="text" formControlName="custom_code" placeholder="-" />
    </div>
  </ng-template>
</form>

